module.exports = __webpack_public_path__ + "static/media/clock.f392d4ec.svg";